import {
  LinkedinIcon,
  LinkedinShareButton,
  TelegramIcon,
  TelegramShareButton,
  TumblrShareCount,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  XIcon,
} from "react-share";

import Single from "../assets/image/select-quiz-img-1.png";
import Public from "../assets/image/select-quiz-img-2.png";
import Self from "../assets/image/select-quiz-img-3.png";
import Searching from "../assets/image/select-quiz-img-4.png";
import PlayerImage from "../assets/image/player-img-1.png";
import PlayerImage2 from "../assets/image/player-img-2.png";
import Close from "../assets/image/close-icon.png";
import CloseGreen from "../assets/image/close-green.png";
import GreenCoin from "../assets/image/coin-icon-green1.png";
import Star from "../assets/image/rate-icon-1.png";
import shineUpgrade from "../assets/image/upgrade-shines.svg";
import UpgradePic from "../assets/image/Upgrade.svg";
import RateStar from "../assets/image/rate-icon-2.png";
import Logout from "../assets/image/logout-icon.png";
import Delete from "../assets/image/delete-icon.png";
import Edit from "../assets/image/editStock.svg";
import Congrats from "../assets/image/cong-icon.png";
import MaintenanceMode from "../assets/image/alert-popup-icon1.png";
import UpdateMode from "../assets/image/alert-popup-icon2.png";
import InternetIssueMode from "../assets/image/alert-popup-icon3.png";
import DeadlinePass from "../assets/image/alert-popup-icon4.png";
import EmailVerified from "../assets/image/alert-popup-icon5.png";
import SomethingWentWrong from "../assets/image/alert-popup-icon6.png";
import AlertIcon from "../assets/image/alertIcon.svg";
import AppleStore from "../assets/image/apple-app-store.svg";
import AppStore from "../assets/image/app-store.svg";
import SideLogoImage from "../assets/image/login1.svg";
import OtpInput from "react-otp-input";

import Documents from "../assets/image/license-img.jpg";
import ShareIcon from "../assets/image/share-icon.png";
import "../style/component/modal.css";
import "../style/component/lockUpgrade.css";
import { Link, useNavigate } from "react-router-dom";
import { CopyText } from "./common";
import PdfView from "../component/profile/pdfView";
import { pdfjs } from "react-pdf";
import { useDispatch, useSelector } from "react-redux";
import { getUserData } from "../redux/selectors/selector";
import { useEffect, useState } from "react";
import Level from "../component/profile/level";
import { Get, Postdata } from "./api.services";
import HttpService from "./https.services";
import { toast } from "react-toastify";
import MyLevels from "../component/profile/myLevels";
import { loginClear } from "../redux/actions/auth.action";
import CloseIcon from "../assets/image/close-icon.png";
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();

export const SelectModal = ({ isActive, onClose, title, children }) => {
  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content">
        <div className="modal-close" onClick={onClose}>
          <img src={Close} alt="Close" />
        </div>
        <h3 className="popup-title">Select Quiz Mode</h3>
        <div className="select-quiz-boxes d-flex justify-content-between">
          <div className="select-quiz-box">
            <div className="img-wrap">
              <img src={Single} alt="Single" />
            </div>
            <h3>1 VS 1</h3>
          </div>
          <div className="select-quiz-box">
            <div className="img-wrap">
              <img src={Public} alt="Public" />
            </div>
            <h3>Public</h3>
          </div>
        </div>
        <div className="popup-cta">
          <button className="cta-btn cta-fill cta-lg">Start</button>
        </div>
      </div>
    </div>
  );
};

export const WaitingModal = ({ isActive, onClose, title, children }) => {
  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content">
        <div className="modal-close" onClick={onClose}>
          <img src={Close} alt="Close" />
        </div>
        <h3 className="popup-title">Searching...</h3>
        <div className="select-quiz-boxes d-flex justify-content-between">
          <div className="select-quiz-box">
            <div className="img-wrap">
              <img src={Self} alt="Self" />
            </div>
            <h3>You</h3>
          </div>
          <div className="select-quiz-box">
            <div className="img-wrap">
              <img src={Searching} alt="Searching" />
            </div>
            <h3>Searching</h3>
          </div>
        </div>
        <div className="select-quiz-timer">
          Quiz Starts in <span>00:20</span>
        </div>
      </div>
    </div>
  );
};

export const QuizResultModal = ({
  isActive,
  onClose,
  title,
  children,
  rewards,
  UserData,
}) => {
  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content">
        <div className="modal-close" onClick={onClose}>
          <img src={Close} alt="Close" />
        </div>
        <h3 className="popup-title">Quiz Result</h3>
        <div className="quiz-result">
          <div className="quiz-result-box d-flex align-items-center">
            <div className="number">1</div>
            <div className="player-img">
              <img src={UserData?.profile_pic} alt="Player" />
            </div>
            <div className="player-name">{UserData?.username}</div>
            <div className="player-earn ms-auto">
              <img src={GreenCoin} alt="GreenCoin" /> {rewards}
            </div>
          </div>
        </div>
        <div className="popup-cta">
          {/* <div className="cta-inline d-flex flex-wrap"> */}
          {/* <div className="cta-wrap">
              <button className="cta-btn cta-fill cta-lg">Get 2X AD</button>
            </div> */}
          <div className="cta-wrap mt-2">
            <Link className="cta-btn cta-fill cta-lg" to="/home/quiz">
              Claim
            </Link>
          </div>
          {/* </div> */}
        </div>
      </div>
    </div>
  );
};

export const RatingModal = ({ isActive, onClose, title, children }) => {
  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content">
        <div className="modal-close" onClick={onClose}>
          <img src={Close} alt="Close" />
        </div>
        <h3 className="popup-title">Rate Rally Bulls</h3>
        <div className="rate-popup-wrap">
          <ul className="d-flex justify-content-center">
            <li>
              <img src={Star} alt="star" />
            </li>
            <li>
              <img src={Star} alt="star" />
            </li>
            <li>
              <img src={Star} alt="star" />
            </li>
            <li>
              <img src={Star} alt="star" />
            </li>
            <li>
              <img src={Star} alt="star" />
            </li>
          </ul>
        </div>
        <div className="popup-cta">
          <button className="cta-btn cta-fill cta-lg">Submit</button>
        </div>
      </div>
    </div>
  );
};

export const CancelContestModal = ({
  isActive,
  onClose,
  title,
  children,
  onClick,
  type,
  customTitle,
  description,
}) => {
  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content">
        <div className="modal-close" onClick={onClose}>
          <img src={Close} alt="Close" />
        </div>
        <div className="icon-wrap">
          <img src={Logout} alt="Logout" />
        </div>
        <h3 className="popup-title">
          {customTitle
            ? customTitle
            : type === "trading"
            ? "Delete Portfolio"
            : `Leave ${title}`}
        </h3>
        {description ? (
          <p>{description}</p>
        ) : children ? (
          children
        ) : (
          <p>
            Are you sure you want to leave{" "}
            {type === "trading" ? "portfolio" : title}?
          </p>
        )}
        <div className="popup-cta">
          <div className="cta-inline d-flex flex-wrap">
            <div className="cta-wrap">
              <button className="cta-btn cta-fill cta-lg" onClick={onClick}>
                Yes, I’m Sure
              </button>
            </div>
            <div className="cta-wrap">
              <button
                className="cta-btn cta-white-fill cta-lg"
                onClick={onClose}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const CancelSubscriptionModal = ({
  isActive,
  onClose,
  title,
  children,
  onClick,
  onConfirm,
}) => {
  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content">
        <div className="modal-close" onClick={onClose}>
          <img src={Close} alt="Close" />
        </div>
        <div className="icon-wrap">
          <img src={Logout} alt="Logout" />
        </div>
        <h3 className="popup-title">Cancel Subscription</h3>
        <p>Are you sure you want to cancel subscription?</p>
        <div className="popup-cta">
          <div className="cta-inline d-flex flex-wrap">
            <div className="cta-wrap">
              <button className="cta-btn cta-fill cta-lg" onClick={onConfirm}>
                Yes, I’m Sure
              </button>
            </div>
            <div className="cta-wrap">
              <button
                className="cta-btn cta-white-fill cta-lg"
                onClick={onClose}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const CancelVoucherModal = ({
  isActive,
  onClose,
  title,
  children,
  onClick,
  onConfirm,
}) => {
  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content">
        <div className="modal-close" onClick={onClose}>
          <img src={Close} alt="Close" />
        </div>
        <div className="icon-wrap">
          <img src={Logout} alt="Logout" />
        </div>
        <h3 className="popup-title">Purchase Voucher</h3>
        <p>{title}</p>
        <div className="popup-cta">
          <div className="cta-inline d-flex flex-wrap">
            <div className="cta-wrap">
              <button className="cta-btn cta-fill cta-lg" onClick={onConfirm}>
                Yes, I’m Sure
              </button>
            </div>
            <div className="cta-wrap">
              <button
                className="cta-btn cta-white-fill cta-lg"
                onClick={onClose}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export const LockUpgradeModal = ({
  isActive,
  onClose,
  title,
  children,
  onClick,
  type,
  message,
}) => {
  const navigate = useNavigate();
  const handleUpgradeClick = () => {
    onClose(); // Close the modal
    navigate("/home/profile/plus"); // Navigate to the upgrade page
  };

  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      {type === "IR" ? (
        <div className="modal-content">
          <div
            className="modal-close"
            onClick={() => navigate("/home/marketPreview")}
          >
            <img src={Close} alt="Close" />
          </div>
          <div className="overlay-content p-0">
            <img src={UpgradePic} alt="Upgrade" />
            <h2 className="mt-2">Limit Exceeded</h2>
            <p>{message}</p>
            <button
              className="overlay-button cta-btn cta-fill px-4 py-2 mt-1"
              onClick={handleUpgradeClick}
            >
              <img
                src={shineUpgrade}
                alt="Upg"
                style={{ marginRight: "10px" }}
              />{" "}
              Upgrade Plan
            </button>
          </div>
        </div>
      ) : (
        <div className="modal-content">
          <div className="modal-close" onClick={onClose}>
            <img src={Close} alt="Close" />
          </div>
          <div className="overlay-content p-0">
            <h2>Upgrade Plan</h2>
            <p>
              <span>{title}</span> is not included in your current plan
            </p>
            <img src={UpgradePic} alt="Upgrade" />
            <p>
              You can upgrade your plan anytime and start accessing{" "}
              <span>{title}</span>
            </p>

            <button
              className="overlay-button cta-btn cta-fill"
              onClick={handleUpgradeClick}
            >
              <img
                src={shineUpgrade}
                alt="Upg"
                style={{ marginRight: "10px" }}
              />{" "}
              Upgrade
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export const LogoutModal = ({
  isActive,
  onClose,
  title,
  children,
  onClick,
}) => {
  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content">
        <div className="modal-close" onClick={onClose}>
          <img src={Close} alt="Close" />
        </div>
        <div className="icon-wrap">
          <img src={Logout} alt="Logout" />
        </div>
        <h3 className="popup-title">Log Out</h3>
        <p>Are you sure you want to log out?</p>
        <div className="popup-cta">
          <div className="cta-inline d-flex flex-wrap">
            <div className="cta-wrap">
              <button className="cta-btn cta-fill cta-lg" onClick={onClick}>
                Yes, I’m Sure
              </button>
            </div>
            <div className="cta-wrap">
              <button
                className="cta-btn cta-white-fill cta-lg"
                onClick={onClose}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const EditStockModal = ({
  isActive,
  onClose,
  title,
  children,
  onConfirm,
}) => {
  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content">
        <div className="modal-close" onClick={onClose}>
          <img src={Close} alt="Close" />
        </div>
        <div className="icon-wrap">
          <img src={Edit} alt="Delete" />
        </div>
        <h3 className="popup-title">Update Portfolio</h3>
        <p>Are you sure you want to update & save portfolio?</p>
        <div className="popup-cta">
          <div className="cta-inline d-flex flex-wrap">
            <div className="cta-wrap">
              <button className="cta-btn cta-fill cta-lg" onClick={onConfirm}>
                Yes, I’m Sure
              </button>
            </div>
            <div className="cta-wrap">
              <button
                className="cta-btn cta-white-fill cta-lg"
                onClick={onClose}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const RemoveStockModal = ({
  isActive,
  onClose,
  title,
  children,
  onConfirm,
}) => {
  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content">
        <div className="modal-close" onClick={onClose}>
          <img src={Close} alt="Close" />
        </div>
        <div className="icon-wrap">
          <img src={Delete} alt="Delete" />
        </div>
        <h3 className="popup-title">Remove Stock</h3>
        <p>Are you sure you want to this stock from portfolio?</p>
        <div className="popup-cta">
          <div className="cta-inline d-flex flex-wrap">
            <div className="cta-wrap">
              <button className="cta-btn cta-fill cta-lg" onClick={onConfirm}>
                Yes, I’m Sure
              </button>
            </div>
            <div className="cta-wrap">
              <button
                className="cta-btn cta-white-fill cta-lg"
                onClick={onClose}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const DeleteModal = ({ isActive, onClose, title, children }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const deletehandler = () => {
    Get(HttpService()?.deleteUser)
      .then((result) => {
        if (result.status) {
          toast.success(result?.message);
          navigate("/");
        } else {
          toast.error(result.message);
        }
      })
      .catch((e) => {
        toast.error(e?.response?.data?.message);
      })
      .finally(() => {
        onClose(); // Close the modal after delete action is handled
      });
  };

  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content">
        <div className="modal-close" onClick={onClose}>
          <img src={Close} alt="Close" />
        </div>
        <div className="icon-wrap">
          <img src={Delete} alt="Delete" />
        </div>
        <h3 className="popup-title">Delete Account</h3>
        <p>Are you sure you want to delete your account?</p>
        <div className="popup-cta">
          <div className="cta-inline d-flex flex-wrap">
            <div className="cta-wrap">
              <button
                className="cta-btn cta-fill cta-lg"
                onClick={deletehandler}
              >
                Yes, I’m Sure
              </button>
            </div>
            <div className="cta-wrap">
              <button
                className="cta-btn cta-white-fill cta-lg"
                onClick={onClose}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const CongraulationModal = ({
  isActive,
  onClose,
  title,
  children,
  onClick,
}) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const handleClick = (event) => {
    onClick(event);
    // if (!isButtonDisabled) {
    //   setIsButtonDisabled(true);
    //   onClick(event); // Call the passed onClick function
    // }
  };
  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content">
        <div className="icon-wrap">
          <img src={Congrats} alt="Congrats" />
        </div>
        <h3 className="popup-title">Congratulations</h3>
        <p>{title}</p>
        <div className="popup-cta">
          <button
            className="cta-btn cta-fill cta-lg"
            onClick={handleClick}
            // disabled={isButtonDisabled}
          >
            Ok
          </button>
        </div>
      </div>
    </div>
  );
};

export const ShowHomePagePopups = ({
  isActive,
  onClose,
  title,
  children,
  onClick,
  promoCode: fallbackPromoCode,
}) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [image, setImage] = useState(null);
  const [promoCode, setPromoCode] = useState(fallbackPromoCode || "");
  const navigate = useNavigate();

  const findPremiumPlan = (plans) =>
    plans.find((plan) => plan?.name?.trim().toLowerCase() === "premium") ||
    plans.find((plan) => plan?.name?.toLowerCase().includes("premium"));

  const handleClick = async () => {
    if (isButtonDisabled) return;
    setIsButtonDisabled(true);
    try {
      const monthlyResponse = await Get(HttpService()?.subscriptions, {
        params: { type: "month" },
      });
      let plans = monthlyResponse?.status ? monthlyResponse.data || [] : [];
      let premiumPlan = findPremiumPlan(plans);

      if (!premiumPlan) {
        const yearlyResponse = await Get(HttpService()?.subscriptions, {
          params: { type: "year" },
        });
        plans = yearlyResponse?.status ? yearlyResponse.data || [] : [];
        premiumPlan = findPremiumPlan(plans);
      }

      if (!premiumPlan) {
        toast.error("Premium plan is not available.");
        return;
      }

      navigate("/home/profile/plus/select-voucher", {
        state: {
          id: premiumPlan._id,
          type: "subscription",
          product_id: premiumPlan.stripe_product_id,
          amount:
            premiumPlan.currency === "USD"
              ? premiumPlan.original_price_in_dollar
              : premiumPlan.original_price,
          promoCode: promoCode || fallbackPromoCode || "",
        },
      });
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Unable to open the premium plan."
      );
    } finally {
      setIsButtonDisabled(false);
    }
  };

  // Fetch home page popup data
  useEffect(() => {
    Get(HttpService()?.homePagePopups)
      .then((response) => {
        if (response?.status) {
          setImage(response?.data?.image);
          if (response?.data?.promocode) {
            setPromoCode(response.data.promocode);
          }
        } else {
          toast.error(response?.message);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);
      });
  }, []);

  return (
    <div className={`modal homepage-popup-modal ${isActive ? "active" : ""}`}>
      <div className="modal-content">
        <button
          className="modal-close absolute mb-3 right-3 bg-transparent border-none p-2 text-gray-500 hover:text-gray-800"
          style={{ background: "none", border: "none", cursor: "pointer", top: "-1px", right: "-2px" }}
          onClick={onClose} // Directly call onClose here
          aria-label="Close popup"
        >
          <img src={CloseIcon} alt="Close" />
        </button>
        <div className="icon-wrap">
          <img src={image} alt="Congrats" />
        </div>
        <div className="popup-cta homepage-popup-cta">
          <button
            className="cta-btn cta-fill cta-lg"
            onClick={handleClick}
            disabled={isButtonDisabled}
          >
            Get
          </button>
        </div>
      </div>
    </div>
  );
};


export const PromoCodeDiscountModal = ({
  isActive,
  onClose,
  couponData,
  onClick,
}) => {
  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content">
        <div className="modal-close" onClick={onClose}>
          <img src={Close} alt="Close" />
        </div>
        <h3 className="popup-title mb-3">Price Breakup</h3>
        <div>
          <div className="d-flex justify-content-between">
            <p className="text-black">Amount with Processing Fee</p>
            <p className="text-black">${couponData?.subtotal}</p>
          </div>
          <div className="d-flex justify-content-between">
            <p className="fw-semibold">Discount</p>
            <p className="fw-semibold">- ${couponData?.discount}</p>
          </div>
          {/* <div className="d-flex justify-content-between">
            <p className="fw-semibold">Tax</p>
            <p className="fw-semibold">- ${couponData?.tax?.toFixed(2)}</p>
          </div> */}
          <div className="border-secondary border-1 mb-2" style={{ borderStyle: "dashed" }}></div>
          <div className="d-flex justify-content-between">
            <p className="text-black">Total Amount</p>
            <p className="text-black">${couponData?.total}</p>
          </div>
        </div>
        <div className="popup-cta">
          <button
            className="cta-btn cta-fill cta-lg"
            onClick={onClick}
            // disabled={isButtonDisabled}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export const CourseCongraulationModal = ({
  isActive,
  onClose,
  title,
  children,
  onClick,
  course,
  courseCompleteCoin,
  lmsdetails,
}) => {
  const navigate = useNavigate();
  //api call

  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content">
        <div className="modal-close" onClick={onClose}>
          <img src={Close} alt="Close" />
        </div>
        <div className="icon-wrap">
          <img src={Congrats} alt="Congrats" />
        </div>
        <h3 className="popup-title">Congratulations! You have won</h3>
        <h4
          className="mb-2 course__card__coins text-center"
          style={{ fontSize: "25px" }}
        >
          <img src={GreenCoin} width="20" alt="GreenCoin" />
          {courseCompleteCoin}
        </h4>
        <p>{title}</p>
        <div className="popup-cta">
          {/* <div className="cta-inline d-flex flex-wrap"> */}
          {/* <div className="cta-wrap">
              <button className="cta-btn cta-fill cta-lg"
                onClick={onClick}
              >
                Download
              </button>
            </div> */}
          <div className="cta-wrap">
            <button
              className="cta-btn cta-fill cta-lg"
              onClick={() =>
                navigate("/lms/common", {
                  state: { id: course?._id, lmsdetails: lmsdetails },
                })
              }
            >
              Start Again
            </button>
          </div>
          {/* <button className="cta-btn cta-fill cta-lg" onClick={onClick}>
            Download
          </button> */}
        </div>
        {/* </div> */}
      </div>
    </div>
  );
};

export const BadgesCongraulationModal = ({
  isActive,
  onClose,
  onBadgeShare,
  title,
  children,
  onClick,
  badges,
  shareURL,
}) => {
  console.log(badges, "406");

  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content">
        <div className="modal-close-bedges" onClick={onClose}>
          <img src={Close} alt="Close" />
        </div>
        <div className="badge-image-wrap">
          <img src={badges?.image} alt="Badge" />
        </div>
        {badges?.is_checked === true ? (
          <>
            <h3 className="popup-title">Congratulations....!</h3>
            <p>
              You have earned the New {badges?.name} Badge on{" "}
              <a href="https://rallybulls.com/"> Rally Bulls</a>
            </p>
            <div className="popup-cta" onClick={onBadgeShare}>
              <div className="share-icon-list">
                <div className="social-icon">
                  <WhatsappShareButton
                    url={shareURL}
                    title={title}
                    separator=":: "
                    className="Demo__some-network__share-button"
                  >
                    <WhatsappIcon size={40} className="share-custom-icon" />
                  </WhatsappShareButton>
                </div>
                <div className="social-icon">
                  <LinkedinShareButton
                    url={shareURL}
                    title={title}
                    className="Demo__some-network__share-button"
                  >
                    <LinkedinIcon size={40} className="share-custom-icon" />
                  </LinkedinShareButton>
                </div>
                <div className="social-icon">
                  <TwitterShareButton
                    url={shareURL}
                    title={title}

                    // className="Demo__some-network__share-button"
                  >
                    <XIcon size={40} className="share-custom-icon" />
                  </TwitterShareButton>
                </div>
                <div className="social-icon">
                  <TelegramShareButton
                    url={shareURL}
                    title={title}
                    className="Demo__some-network__share-button"
                  >
                    <TelegramIcon size={40} className="share-custom-icon" />
                  </TelegramShareButton>
                </div>
              </div>
              {/* <a href="javascript:;">
          <button className="cta-btn cta-fill cta-lg">
            Share
          </button>
          </a> */}
            </div>
          </>
        ) : (
          <>
            <h3 className="popup-title-des">{badges?.description}</h3>
          </>
        )}
      </div>
    </div>
  );
};

// export const QuizCompleteModal = ({
//   isActive,
//   onClose,
//   title,
//   children,
//   onClick,
//   grade,
//   passGrade = 80,
// }) => {
//   const formattedGrade = (grade !== null && grade !== undefined && !isNaN(grade))
//     ? grade.toFixed(2)
//     : null;

//   const passed = grade >= passGrade;
//   const scoreStyle = {
//     color: passed ? "green" : "red",
//     borderColor: passed ? "green" : "red",
//   };

//   return (
//     <div className={`modal ${isActive ? "active" : ""}`}>
//       <div className="modal-content">
//         <div className="result-container">
//           <div className="score-circle" style={scoreStyle}>
//             {formattedGrade}%
//           </div>
//           <p>{title}</p>
//           <p>Pass grade is: {passGrade}%</p>
//           {
//            grade <= passGrade  ?
//            <div className="popup-cta">
//            <button className="cta-btn cta-fill cta-lg" onClick={onClick}>
//              Restartsss
//            </button>
//          </div> : null
//           }

//         </div>
//       </div>
//     </div>
//   );
// };

export const QuizStartModal = ({ isActive, onClick }) => {
  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content">
        <div className="headling_quiz">Quiz</div>
        <p>To Pass the Quiz you must answer</p>
        <p>80% of the questions correctly</p>
        <div className="popup-cta">
          <button className="cta-btn cta-fill cta-lg" onClick={onClick}>
            Get Started
          </button>
        </div>
      </div>
    </div>
  );
};

export const UpdateNotificationModal = ({
  isActive,
  onClose,
  title,
  children,
}) => {
  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content">
        <div className="modal-close" onClick={onClose}>
          <img src={Close} alt="Close" />
        </div>
        <div className="icon-wrap">
          <img src={UpdateMode} alt="Update" />
        </div>
        <h3 className="popup-title">Update Available</h3>
        <p>Please update the application for better experience</p>
        <div className="popup-cta">
          <button className="cta-btn cta-fill cta-lg">Ok</button>
        </div>
      </div>
    </div>
  );
};

export const MaintainceModeModal = ({ isActive, onClose, title, children }) => {
  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content">
        {/* <div className="modal-close" onClick={onClose}>
          <img src={Close} alt="Close" />
        </div> */}
        <div className="icon-wrap">
          <img src={MaintenanceMode} alt="Maintence" />
        </div>
        <h3 className="popup-title">Maintenance Mode</h3>
        <p>Application is under maintenance</p>
        <div className="popup-cta">
          <button className="cta-btn cta-fill cta-lg">Ok</button>
        </div>
      </div>
    </div>
  );
};

export const AlreadyLoggedModal = ({ isActive, onClose, title, children }) => {
  const onClick = () => {
    onClose();
    window.location.href = "/";
  };
  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content">
        {/* <div className="modal-close" onClick={onClose}>
          <img src={Close} alt="Close" />
        </div> */}
        <div className="icon-wrap">
          <img src={AlertIcon} alt="Maintence" />
        </div>
        <h3 className="popup-title">Ohh!</h3>
        <p>You are already logged in in another device, please log in again</p>
        <div className="popup-cta">
          <button className="cta-btn cta-fill cta-lg" onClick={onClick}>
            Ok
          </button>
        </div>
      </div>
    </div>
  );
};

export const MobileViewModal = ({ isActive, onClose, title, children }) => {
  const onClick = () => {
    onClose();
  };
  return (
    <div
      className={`modal ${isActive ? "active" : ""}`}
      style={{ backdropFilter: "blur(2px)" }}
    >
      <div
        className="modal-content"
        style={{
          maxWidth: "420px",
          boxShadow: "#5aa771 0px 0px 17px 3px inset",
        }}
      >
        {/* <div className="modal-close" onClick={onClose}>
          <img src={Close} alt="Close" />
        </div> */}
        <div className="icon-wrap">
          <img src={SideLogoImage} alt="Maintence" style={{ width: "31%" }} />
        </div>
        <h3 className="popup-title">Want to use our App?</h3>
        <p>Get it now</p>
        <div className="icon-wrap d-flex justify-content-center gap-2">
          <a
            href="https://play.google.com/store/apps/details?id=com.app.rallybulls"
            target="_blank"
          >
            {" "}
            <img src={AppStore} alt="Maintence" />
          </a>
          <a
            href="https://apps.apple.com/in/app/rally-bulls/id6484273826"
            target="_blank"
          >
            <img src={AppleStore} alt="Maintence" />
          </a>
        </div>
        {/* <div className="popup-cta">
          <button className="cta-btn cta-fill cta-lg" onClick={onClick}>
            Ok
          </button>
        </div> */}
      </div>
    </div>
  );
};

export const InternetIssueModeModal = ({
  isActive,
  onClose,
  title,
  children,
}) => {
  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content">
        <div className="modal-close" onClick={onClose}>
          <img src={Close} alt="Close" />
        </div>
        <div className="icon-wrap">
          <img src={InternetIssueMode} alt="Internet" />
        </div>
        <h3 className="popup-title">Offline Mode</h3>
        <p>
          It looks like you're offline. Please check your internet connection
        </p>
        <div className="popup-cta">
          <button className="cta-btn cta-fill cta-lg">Ok</button>
        </div>
      </div>
    </div>
  );
};

export const DeadlinePassModal = ({ isActive, onClose, title, children }) => {
  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content">
        <div className="modal-close" onClick={onClose}>
          <img src={Close} alt="Close" />
        </div>
        <div className="icon-wrap">
          <img src={DeadlinePass} alt="Deadline" />
        </div>
        <h3 className="popup-title">Deadline Passed</h3>
        <p>Deadline for this contest has passed</p>
        <div className="popup-cta">
          <button className="cta-btn cta-fill cta-lg">Ok</button>
        </div>
      </div>
    </div>
  );
};

export const EmailVerifiedModal = ({ isActive, onClose, title, children }) => {
  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content">
        <div className="modal-close" onClick={onClose}>
          <img src={Close} alt="Close" />
        </div>
        <div className="icon-wrap">
          <img src={EmailVerified} alt="Email" />
        </div>
        <h3 className="popup-title">Email Verified</h3>
        <p>Your Email Id is verified successfully</p>
        <div className="popup-cta">
          <button className="cta-btn cta-fill cta-lg">Ok</button>
        </div>
      </div>
    </div>
  );
};

export const SomethingWentWrongModal = ({
  isActive,
  onClose,
  title,
  children,
}) => {
  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content">
        <div className="modal-close" onClick={onClose}>
          <img src={Close} alt="Close" />
        </div>
        <div className="icon-wrap">
          <img src={SomethingWentWrong} alt="Error" />
        </div>
        <h3 className="popup-title">Something Went Wrong</h3>
        <p>Some error has occured</p>
        <div className="popup-cta">
          <button className="cta-btn cta-fill cta-lg">Ok</button>
        </div>
      </div>
    </div>
  );
};
export const CertificatePreviewModal = ({
  isActive,
  onClose,
  onShare,
  title,
  children,
  CertiURL,
}) => {
  console.log(CertiURL, "CertiURL");
  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content-certificate image-popup">
        <div className="modal-close-certificate" onClick={onClose}>
          <img src={CloseGreen} alt="Close" />
        </div>

        <div className="popup-share" onClick={onShare}>
          <a href="javascript:;">
            <img src={ShareIcon} alt="ShareIcon" />
          </a>
        </div>
        <div className="img-wrap">
          <img
            src={CertiURL?.certificatePreviewUrl}
            alt="Loading.."
            style={{ width: "800px" }}
          />
          {/* <PdfView url={CertiURL}/> */}
          {/* <iframe
            src={`https://docs.google.com/viewer?url=${CertiURL}&embedded=true`}
            frameborder="0"
            height="580px"
            width="800px"
          ></iframe> */}
        </div>
      </div>
    </div>
  );
};
export const ShareModal = ({ isOpen, onCloseModel, shareURL, title }) => {
  console.log(578, shareURL);
  // const title = "I earned this Certificate";
  return (
    <div className={`modal ${isOpen ? "active" : ""}`}>
      <div className="modal-content-certificate-share image-popup  p-4">
        <div
          className="modal-close-certificate"
          style={{ bottom: "77%" }}
          onClick={onCloseModel}
        >
          <img src={CloseGreen} alt="Close" />
        </div>
        <h6 className="text-center">Share Certificate</h6>
        <div className="share-icon-list">
          <div className="social-icon">
            <LinkedinShareButton
              url={shareURL}
              title={title}
              className="Demo__some-network__share-button"
            >
              <LinkedinIcon size={40} className="share-custom-icon" />
            </LinkedinShareButton>
          </div>
          <div className="social-icon">
            <TwitterShareButton
              url={shareURL}
              title={title}

              // className="Demo__some-network__share-button"
            >
              <XIcon size={40} className="share-custom-icon" />
            </TwitterShareButton>
          </div>
          <div className="social-icon">
            <TelegramShareButton
              url={shareURL}
              title={title}
              className="Demo__some-network__share-button"
            >
              <TelegramIcon size={40} className="share-custom-icon" />
            </TelegramShareButton>
          </div>
          <div className="social-icon">
            <WhatsappShareButton
              url={shareURL}
              title={title}
              separator=":: "
              className="Demo__some-network__share-button"
            >
              <WhatsappIcon size={40} className="share-custom-icon" />
            </WhatsappShareButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export const ShareContestModal = ({
  isOpen,
  onCloseModel,
  shareURL,
  prizePool,
  EntryFee,
  InviteCode,
  name,
  type,
  typeOf,
}) => {
  console.log(578, shareURL);
  const toBoldUnicode = (text) =>
    text
      ?.split("")
      ?.map((char) => {
        if (char >= "0" && char <= "9") {
          return String.fromCodePoint(0x1d7ce + (char.charCodeAt(0) - 48));
        } else if (char >= "A" && char <= "Z") {
          return String.fromCodePoint(0x1d400 + (char.charCodeAt(0) - 65));
        } else if (char >= "a" && char <= "z") {
          return String.fromCodePoint(0x1d41a + (char.charCodeAt(0) - 97));
        }
        return char;
      })
      .join("");

  const boldInviteCode = toBoldUnicode(InviteCode);
  const title = `I have challenged you to this ${name} fantasy on RALLYBULLS!\n\nPrize Pool: ${prizePool}\nEntry Coins: ${EntryFee}\nINVITE CODE: ${boldInviteCode}\n\nTap below link for join:\n${shareURL}\n`;
  const titlePublic = `I have challenged you to this ${name} fantasy on RALLYBULLS!\n\nPrize Pool: ${prizePool}\nEntry Coins: ${EntryFee}\nINVITE CODE: ${boldInviteCode}\n\nTap below link for join:\n${shareURL}\n`;
  return (
    <div className={`modal ${isOpen ? "active" : ""}`}>
      <div className="modal-content-contest-share image-popup  p-4">
        <div className="modal-close-contest" onClick={onCloseModel}>
          <img src={Close} alt="Close" />
        </div>
        <div>
          <h2 className="text-center h6 mb-3">
            Share {typeOf === "fantasy" ? "Fantasy" : "Contest"}{" "}
          </h2>
        </div>
        <div className="mb-2">
          <p>
            I have challenged you to this New{" "}
            {typeOf === "fantasy" ? "fantasy" : "contest"} on RALLYBULLS!
          </p>
        </div>
        <div className="share-icon-list">
          <div className="social-icon">
            <LinkedinShareButton
              url={shareURL}
              title={type === "private" ? title : titlePublic}
              className="Demo__some-network__share-button"
            >
              <LinkedinIcon size={40} className="share-custom-icon" />
            </LinkedinShareButton>
          </div>
          <div className="social-icon">
            <TwitterShareButton
              url={shareURL}
              title={type === "private" ? title : titlePublic}

              // className="Demo__some-network__share-button"
            >
              <XIcon size={40} className="share-custom-icon" />
            </TwitterShareButton>
          </div>
          <div className="social-icon">
            <TelegramShareButton
              url={shareURL}
              title={type === "private" ? title : titlePublic}
              className="Demo__some-network__share-button"
            >
              <TelegramIcon size={40} className="share-custom-icon" />
            </TelegramShareButton>
          </div>
          <div className="social-icon">
            <WhatsappShareButton
              url={"."}
              title={type === "private" ? title : titlePublic}
              // separator="📈"
              className="Demo__some-network__share-button"
            >
              <WhatsappIcon size={40} className="share-custom-icon" />
            </WhatsappShareButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export const DrivingPreviewModal = ({ isActive, onClose, title, children }) => {
  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content">
        <div className="modal-close-certificate" onClick={onClose}>
          <img src={CloseGreen} alt="Close" />
        </div>
        <div className="document img-wrap">
          <img src={Documents} alt="Documents" />
        </div>
      </div>
    </div>
  );
};

export const LevelPreviewModal = ({
  isActive,
  onClose,
  title,
  children,
  CertiURL,
}) => {
  const [LevelData, setLevelData] = useState([]);
  const FetchLevelData = () => {
    Get(HttpService()?.levelHistory)
      .then((response) => {
        if (response?.status) {
          console.log(response.data, "levelHistory");
          setLevelData(response.data?.data);
        } else {
          toast.error(response?.message);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);
      });
  };

  useEffect(() => {
    FetchLevelData();
  }, [isActive]);

  const data = [
    {
      name: "level 1",
      is_completed: true,
      achievement: [
        "RC 100 credited in your wallet as a quiz question rewards of 12 Sep, 2024",
        "You have got 50 coin for Complete Course",
        "RC 100 credited in your wallet as a quiz question rewards of 13 Sep, 2024",
      ],
    },
    {
      name: "level 2",
      is_completed: true,
      achievement: [
        "RC 100 credited in your wallet as a quiz question rewards of 13 Sep, 2024",
        "You have got 50 coin for Complete Course",
        "RC 100 credited in your wallet as a quiz question rewards of 13 Sep, 2024",
      ],
    },
    {
      name: "level 3  ",
      is_completed: false,
      achievement: [
        "RC 100 credited in your wallet as a quiz question rewards of 13 Sep, 2024",
      ],
    },
  ];

  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content-levels image-popup">
        <div className="modal-close-levels" onClick={onClose}>
          <img src={Close} alt="Close" />
        </div>
        <Level levelsData={LevelData} />
        {/* <MyLevels levelsData={data}/> */}
      </div>
    </div>
  );
};

export const OtpModal = ({
  isActive,
  onClose,
  title,
  children,
  onSuccess,
  email,
}) => {
  const [form, setForm] = useState({ otp: 0 });
  const [remainingTime, setRemainingTime] = useState(59);
  const [isResendEnabled, setIsResendEnabled] = useState(false);

  const handleChange = (event) => {
    setForm((prev) => ({ ...prev, otp: event }));
  };

  useEffect(() => {
    if (isActive) {
      setForm({ otp: "" }); // Reset the OTP input field
      setRemainingTime(59); // Restart the timer
      setIsResendEnabled(false); // Disable resend button
    }
  }, [isActive]);

  useEffect(() => {
    let timerInterval;
    if (remainingTime > 0 && isActive) {
      timerInterval = setInterval(() => {
        setRemainingTime((prevTime) => prevTime - 1);
      }, 1000);
    } else if (remainingTime === 0) {
      setIsResendEnabled(true);
    }

    return () => {
      clearInterval(timerInterval);
    };
  }, [remainingTime, isActive]);

  const handleResend = () => {
    setRemainingTime(59); // Reset timer
    setIsResendEnabled(false); // Hide resend text
    if (sendOTP) sendOTP(); // Call the resend OTP function if provided
  };

  console.log(email, "email----");
  const sendOTP = () => {
    var formData = new FormData();
    formData.append("email", email);

    Postdata(HttpService().sendEmail, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((result) => {
        if (result?.status) {
          toast.success(result?.message);
          // setisOtpOpen(true)
        } else {
          console.log("error");
          toast.error(result?.message);
        }
      })
      .catch((e) => {
        toast.error(e?.response?.data?.message);
      });
  };
  // useEffect(() => {
  //   let timerInterval;
  //   if (remainingTime > 0) {
  //     timerInterval = setInterval(() => {
  //       setRemainingTime((prevTime) => prevTime - 1);
  //     }, 1000);
  //   }
  //   return () => {
  //     clearInterval(timerInterval);
  //   };
  // }, [remainingTime]);

  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content">
        <div className="modal-close" onClick={onClose}>
          <img src={Close} alt="Close" />
        </div>
        <p>Please enter OTP for email verification</p>
        <div className="form-wrap auth-form">
          <div className="otp-wrap">
            <div className="otp-fields d-flex justify-content-between">
              <OtpInput
                value={form.otp}
                onChange={handleChange}
                numInputs={4}
                inputType="text"
                placeholder="0000"
                shouldAutoFocus={true}
                inputStyle="otp-field form-control"
                renderInput={(props) => <input {...props} />}
              />
            </div>
            <div className="otp-resend d-flex justify-content-between">
              <span>00:{remainingTime}s</span>
              {isResendEnabled && (
                <Link onClick={handleResend}>Resend Code</Link>
              )}
            </div>
          </div>
          <div className="form-cta">
            <button
              className="cta-btn cta-fill cta-lg"
              onClick={() => {
                onSuccess(form.otp);
              }}
            >
              Verify
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// export const SocialShare = ({
//   isActive,
//   onClose,
//   title,
//   children,
//   referalData,
//   name
// }) => {
//   return (
//     <div className={`modal ${isActive ? "active" : ""}`}>
//       <div className="modals-content">
//         <div className="modal-close" onClick={onClose}>
//           <img src={Close} alt="Close" />
//         </div>
//         <h3 className="popup-title">Share & Earn</h3>
// 					<div className="form-label-md">
// 						<div className="form-group">
// 							<label>Share my referral link</label>
// 							<div className="refferal-wrap d-flex flex-wrap">
// 								<div className="link-wrap">{`https://web.rallybulls.com/?ref=${referalData}`}</div>
// 								<a href="#" className="cta-btn cta-fill" onClick={() => CopyText(`Hey, ${name} has invited you to RALLYBULLS! Use this invite code ${referalData} to sign up and get extra 500 in your RALLYBULLS. https://web.rallybulls.com/`)}>Copy Link</a>
// 							</div>
// 						</div>
// 					</div>
// 					<ul className="social-share d-flex flex-wrap">
// 						<li><a href="#"><img src={Google} alt="Google"/> Import Contacts</a></li>
// 						<li><a href="https://www.facebook.com/" target="_blank"><img src={Facebook} alt="Facebook"/> Facebook</a></li>
// 						<li><a href="https://x.com/?lang=en"><img src={Twitter} alt="Twitter"/> Twitter</a></li>
//             <li><a href="https://web.whatsapp.com/"><img src={whatsapp} alt="whatsapp"/> WhatsApp</a></li>
// 					</ul>
//         {/* <ShareSocial
//           url={`https://web.rallybulls.com/?ref=${referalData}`}
//           socialTypes={["twitter", "reddit", "linkedin", "whatsapp"]}
//         /> */}
//       </div>
//     </div>
//   );
// };
